import React from 'react';
import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';

import {getSearchValues} from '../../../utils/search';
import {MAX_QUERY_LENGTH} from '../../../utils/constant';
import OrganisationList from '../../organisationList';
import ListSearchBar from '../../listSearchBar';
import {useSubcontractorsStore} from '../SubcontractorsStore';

export const SubcontractorsListView = props => {
  const {state: {subcontractors}} = useSubcontractorsStore();
  const location = useLocation();
  const {queryString} = getSearchValues(location.search);
  const [isTyping, setIsTyping] = React.useState(false);

  return (
    <div className="card">
      <ListSearchBar
        onSearch={props.onSearch}
        isTyping={typing => setIsTyping(typing)}
        defaultValue={queryString || ''}
        label={<Translate value="organisation.search.inputLabel"/>}
        placeholder={I18n.t('organisation.search.placeholder')}
        maxQueryLength={MAX_QUERY_LENGTH}
      />
      {subcontractors.error ?
        <Translate value="error.generic"/> :
        <OrganisationList
          type="subcontractor"
          organisations={subcontractors.list}
          onPageChange={props.onPageChange}
          pageNumber={props.pageNumber}
          pageSize={subcontractors.pageSize}
          totalCount={subcontractors.totalCount}
          loading={subcontractors.loading || isTyping}
          onDeleteRelationship={props.onDeleteRelationship}
          dossierCountry={subcontractors.dossierCountry}
        />
      }
    </div>
  );
};

SubcontractorsListView.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  onDeleteRelationship: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired
};

export default SubcontractorsListView;
